import { render, staticRenderFns } from "./PedidosVendas.vue?vue&type=template&id=534d0fe4&"
import script from "./PedidosVendas.vue?vue&type=script&lang=js&"
export * from "./PedidosVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports